// extracted by mini-css-extract-plugin
module.exports = {"withBottomBar":"DrupalUrlNugget__withBottomBar___3WOv3","withoutBottomBar":"DrupalUrlNugget__withoutBottomBar____jPyI"};